<template>
  <div>
    <SynonymListSkeleton
      v-if="isLoadingSynonym"
    />
    <v-list
      v-else
      class="py-2"
      :class="counterXSpaceClass"
    >
      <v-list-item
        v-for="synonym in synonymList"
        :key="`${diagnosticLevel}${synonym.name}`"
        class="synonym-list__item"
        :class="xSpaceClass"
        data-qa="service_synonym_item"
        @click="handleClickItem(synonym)"
      >
        <div class="mr-2">
          <!-- eslint-disable vue/no-v-html -->
          <div
            v-if="isSearchResults"
            class="text-body-1 text--text"
            data-qa="service_synonym_item_title_marked"
            v-html="synonym.nameWithMarkedQuery"
          />
          <!-- eslint-enable vue/no-v-html -->
          <div
            v-else
            class="text-body-1 text--text"
            data-qa="service_synonym_item_title"
          >
            {{ synonym.name }}
          </div>
          <div
            v-if="synonym.price"
            class="text-body-2 text-info--text"
            data-qa="service_synonym_item_price"
          >
            <template v-if="isUsedClub">
              <span
                v-if="synonym.price_with_club"
                class="error--text pr-1"
              >
                {{ getFormattedPrice(synonym.price_with_club) }}
                <template v-if="synonym.duration">
                  &bull; {{ getDurationText(synonym.duration) }}
                </template>
              </span>
              <span :class="{ 'text-decoration-line-through': synonym.price_with_club }">
                {{ getFormattedPrice(synonym.price) }}
                <template v-if="synonym.duration">
                  &bull; {{ getDurationText(synonym.duration) }}
                </template>
              </span>
            </template>
            <template v-else>
              {{ getFormattedPrice(synonym.price) }}
              <template v-if="synonym.duration">
                &bull; {{ getDurationText(synonym.duration) }}
              </template>
            </template>
          </div>
        </div>
        <span class="ml-auto ui-icon-arrow-right text-info--text" />
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import { getFormattedPrice } from 'www/utils'
import SynonymListSkeleton from 'www/vue_components/common/SynonymList/components/common/SynonymListSkeleton.vue'
import CurrencyData from 'www/vue_components/common/mixins/CurrencyData'
import declensionByNum from 'www/utils/executors/declensionByNum'

export default {
  name: 'SynonymListItems',
  components: {
    SynonymListSkeleton,
  },
  mixins: [
    CurrencyData,
  ],
  props: {
    synonymList: {
      type: Array,
      default: () => [],
    },
    diagnosticLevel: {
      type: Number,
      default: null,
    },
    isLoadingSynonym: {
      type: Boolean,
      default: false,
    },
    isSearchResults: {
      type: Boolean,
      default: false,
    },
    isUsedClub: {
      type: Boolean,
      default: false,
    },
    counterXSpaceClass: {
      type: String,
      default: '',
    },
    xSpaceClass: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleClickItem(synonym) {
      this.$emit('synonym-list:click-item', { synonym })
    },
    getFormattedPrice(price) {
      return getFormattedPrice(price)
    },
    getDurationText(duration) {
      return `${duration} ${declensionByNum(duration, ['минута', 'минуты', 'минут'])}`
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/keyframes';

.synonym-list {
  &__item {
    min-height: 0;
    padding: 16px 8px;
    animation: 0.3s ease-in-out fadeIn;
  }
}
</style>
